import { Pipe, PipeTransform } from '@angular/core';
import { StringHHColonmm, StringHHmm, toStringHHColonmm } from '@concretecode/shared';

@Pipe({
  name: 'formatTime',
})
export class FormatTimePipe implements PipeTransform {
  // 'HHmm' => 'HH:mm'
  transform(value: StringHHmm | string | undefined): StringHHColonmm {
    if (!value || value.length !== 4) {
      return toStringHHColonmm('00:00');
    }

    const hours = value.substring(0, 2);
    const minutes = value.substring(2, 4);

    return toStringHHColonmm(`${hours}:${minutes}`);
  }
}
